import db from "@/plugins/dexie";
import apivarejoweb from '@/services/api-varejoweb';
import moment from "moment-timezone";
import store from "@/store";
import $_enviaColetaItem  from "./enviaColetaItem";
import { SetupEnvioLocal } from '@/utils/atualizalocal';


const tabela = 'ordemservico';
const idnuvem = 'orsidnuvem';
export default async function $_enviaColeta() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let coleta = await db[tabela].toArray();
  coleta = coleta.filter(i => i.orsdatanuvem === null && !i.orsexclusao && i.orsdatafechamento);


  const safeInt = (val) => {
    if (val === null || val === undefined || val === '' || val === 'null') return null;
    const num = Number(val);
    if (isNaN(num) || num > 2147483647 || num < -2147483648) return null;
    return num;
  };

  const promises = coleta.map(async (item) => {
    let idEmpresaPayload = safeInt(item.orsidempresa);
    if (!idEmpresaPayload) {
      try {
        const empLocal = await db.empresa.toCollection().first();
        if (empLocal) {
          idEmpresaPayload = safeInt(empLocal.idempresa || empLocal.empidempresa || empLocal.empidnuvem);
        }
      } catch (e) {
        console.warn("Erro ao buscar empresa no Dexie em enviaColeta:", e);
      }
      if (!idEmpresaPayload) {
        const sessEmp = sessionStorage.getItem('empidempresa');
        if (sessEmp) idEmpresaPayload = safeInt(sessEmp);
      }
    }

    const payload = {
      IDEMPRESA: idEmpresaPayload || 1,
      VALOR: 0,
      IDCLIENTE: item.orsidcliente,
      DATACADASTRO: item.orsdatacadastro,
      HORACADASTRO: item.orsdatacadastro ? moment(item.orsdatacadastro).format('HH:mm:ss') : null,
      OBSERVACAOEQUIPAMENTO: item.orsobservacaoextra,
      DEFEITO: item.orsdefeito,
      ORSDataInclusao: item.orsdatacadastro,
      NroExterno: item.orsnroexterno,
      IdVendedorServico: item.orsidvendedor,
      ORSIdUsuarioCadastro: item.orsidvendedor,
      TIPO: 2,
    };

    if (item[idnuvem] && item[idnuvem] !== 'null') payload.IDORDEMSERVICO = item[idnuvem];

    let res = null;
    try {
      if (item[idnuvem] && item[idnuvem] !== 'null') {

        res = await apivarejoweb.put(`/ordemservico/${item[idnuvem]}`, payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      } else {

        res = await apivarejoweb.post('/ordemservico', payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      }
    } catch (err) {
      console.log(err);
    }

    if (res) {
      const alteracao = moment(res.data.ORSDataAlteracao).format('YYYY-MM-DD HH:mm:ss.SSS');
      await db[tabela].update(item.id, {
        orsidvendedor: res.data.orsidvendedor,
        orsidnuvem: res.data.IDORDEMSERVICO ?? item[idnuvem],
        orsdataalteracao: alteracao,
        orsdatanuvem: alteracao,
      });
      store.dispatch('cache/atualizaData', { data: alteracao, tabela: `${tabela}` });
      await store.dispatch('cache/reloadCache', 'ordemservico')
      
      let coletaitens = [];
      try {
        coletaitens = await db.ordemservicoitem.where({osiidordemservicolocal: item.orsidlocal }).toArray();
      } catch {

        coletaitens = await db.ordemservicoitem.where({osiidordemserviconuvem: item[idnuvem]}).toArray();
      }

      

      coletaitens = coletaitens.flatMap((ci) => {
        if (ci.osiidordemserviconuvem) return [];
        return [{
          key: ci.id,
          changes: {
            osiidordemserviconuvem: res.data.IDORDEMSERVICO ?? item[idnuvem],
          }
        }]
      });
      
      await db.ordemservicoitem.bulkUpdate(coletaitens);

    }
    return res;
  });

  const retorno = await Promise.all(promises);


  const idsLocais = coleta.map(item => item.orsidlocal);

  if (retorno.length > 0) {   
    await $_enviaColetaItem(idsLocais);
  }

  try {
    await SetupEnvioLocal({ silent: true });
  } catch (err) {
    console.warn("Aviso: Falha ao executar SetupEnvioLocal pós-envio de Coleta:", err);
  }
}
